import React from 'react';
import PersonalCodeInput from "../../components/PersonalCodeInput.jsx";
import TranslationText from "../../components/Translation/TranslationText.jsx";

export function PersonalCodeEntry({
  personalCode,
  personalCodeError,
  errorText,
  onPersonalCodeChange,
  consentText
}) {
  const displayError = personalCodeError || errorText;

  return (
    <div className="form-group">
      <div className="form-row">
        <div className={`form-field ${displayError ? "-has-error" : ""}`}>
          <label htmlFor="personalCode" className="form-field__label">
            <TranslationText text='personal_code_text_field_label' />
          </label>
          <PersonalCodeInput
            personalCode={personalCode}
            onPersonalCodeChange={onPersonalCodeChange}
          />
          <div className="sublabel error-msg show">
            <span>
              <TranslationText text={displayError} />
            </span>
          </div>
        </div>
      </div>
      {consentText && (
        <div className="consent-text-row">
          <p>
            <TranslationText text={consentText} />
          </p>
        </div>
      )}
    </div>
  );
} 